import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { FormattedMessage, useIntl } from "react-intl";
import { ActivityLogTransports } from "../../../../app/transports/activityLog";
import { TActivityLog } from "../../../../app/types/activityLog";
import moment from "moment";

const Item: FC<any> = ({ activity }) => {
    const { formatMessage } = useIntl();
    return (
        <div className="timeline-item">
            <div className="timeline-line w-40px"></div>

            <div className="timeline-icon symbol symbol-circle symbol-40px">
                <div className="symbol-label bg-light">
                    <KTSVG
                        path="/media/icons/duotune/abstract/abs027.svg"
                        className="svg-icon-2 svg-icon-gray-500"
                    />
                </div>
            </div>
            <div className="timeline-content mb-10 mt-n1">
                <div className="pe-3 mb-5">
                    <div className="fs-5 fw-bold mb-2">{`${formatMessage({
                        id: `layout.log.${activity.action}`,
                    })} ${formatMessage({
                        id: `layout.log.${activity.objectIdentifier}`,
                    })} : ${activity.objectName}`}</div>

                    <div className="d-flex align-items-center mt-1 fs-6">
                        <div className="text-muted me-2 fs-7">
                            {moment(activity.createdAt).format("DD/MM/YYYY HH:mm:ss")}{" "}
                            <FormattedMessage id="layout.log.by" /> {activity.author.name}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ActivityDrawer: FC = () => {
    const [activities, setActivities] = useState<TActivityLog[]>([]);
    useEffect(() => {
        ActivityLogTransports.listUser().then((data) => setActivities(data));
    }, []);

    return (
        <div
            id="kt_activities"
            className="bg-body w-25"
            data-kt-drawer="true"
            data-kt-drawer-name="activities"
            data-kt-drawer-activate="true"
            data-kt-drawer-overlay="true"
            data-kt-drawer-direction="end"
            data-kt-drawer-toggle="#kt_activities_toggle"
            data-kt-drawer-close="#kt_activities_close"
        >
            <div className="card shadow-none rounded-0">
                <div className="card-header" id="kt_activities_header">
                    <h3 className="card-title fw-bolder text-dark">
                        <FormattedMessage id="layout.log.title" />
                    </h3>

                    <div className="card-toolbar">
                        <button
                            type="button"
                            className="btn btn-sm btn-icon btn-active-light-primary me-n5"
                            id="kt_activities_close"
                        >
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon-1"
                            />
                        </button>
                    </div>
                </div>
                <div className="card-body position-relative" id="kt_activities_body">
                    <div
                        id="kt_activities_scroll"
                        className="position-relative scroll-y me-n5 pe-5"
                        data-kt-scroll="true"
                        data-kt-scroll-height="auto"
                        data-kt-scroll-wrappers="#kt_activities_body"
                        data-kt-scroll-dependencies="#kt_activities_header, #kt_activities_footer"
                        data-kt-scroll-offset="5px"
                    >
                        <div className="timeline">
                            {activities &&
                                activities.map((activity, index) => (
                                    <Item key={index} activity={activity} />
                                ))}
                        </div>
                    </div>
                </div>
                <div className="card-footer py-5 text-center" id="kt_activities_footer">
                    <Link to="/activity" className="btn btn-bg-body text-primary">
                        <FormattedMessage id="layout.log.viewall" />
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr064.svg"
                            className="svg-icon-3 svg-icon-primary"
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export { ActivityDrawer };
